"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9181],{

/***/ 21632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ShareMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48261);
/* harmony import */ var _components_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99129);






var ShareMenu = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? "light-bg" : _theme, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme"
    ]);
    var color = theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textStrong */ .O9.textStrong : plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("align-self:flex-end;display:flex;align-items:center;"),
        className: "share-page",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:13px;line-height:1.5;color:", color, ";margin-right:10px;"),
                children: "このページをシェア"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(HoverEffectLink, {
                href: (0,_lib_url__WEBPACK_IMPORTED_MODULE_1__/* .twitterShareUrl */ .nv)(props.url, props.title),
                hoverColor: plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.twitter */ .O9.twitter,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_2__/* .TwitterIcon */ .Zm, {
                    size: 22,
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:", color, ";")
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(HoverEffectLink, {
                href: (0,_lib_url__WEBPACK_IMPORTED_MODULE_1__/* .facebookShareUrl */ .mk)(props.url),
                hoverColor: plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.facebook */ .O9.facebook,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_2__/* .FacebookIcon */ .Vq, {
                    size: 22,
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:", color, ";")
                })
            })
        ]
    });
};
var HoverEffectLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
        href: props.href,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:50%;&,i{transition:0.3s;}&:hover{background-color:", props.hoverColor, ";i{color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";}}"),
        target: "_blank",
        rel: "noopener noreferrer",
        suppressHydrationWarning: true,
        children: props.children
    });
};


/***/ }),

/***/ 94580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ CompanyAndInvestorSummaryBg; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var CompanyAndInvestorSummaryBg = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:100%;max-width:", props.sticky ? "100%" : "1280px", ";margin-inline:auto;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{position:sticky;z-index:20;top:-200px;transition:max-width 0.16s 0s linear;}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("min-height:196px;display:flex;justify-content:space-between;flex-direction:column;position:relative;background-blend-mode:multiply;background:url(", props.backgroundImage, ") 50% 0 no-repeat,linear-gradient(\n                to bottom,", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.blueGray50 */ .O9.blueGray50, " 0,transparent 196px\n              )\n              no-repeat;background-size:auto 196px;border-radius:0;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{min-height:360px;background:url(", props.backgroundImage, ") 50% 50% no-repeat,linear-gradient(\n                to bottom,", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.blueGray50 */ .O9.blueGray50, " 100%,transparent 0\n              );background-size:cover;border-radius:", props.sticky ? "0" : "8px", ";}"),
            children: props.children
        })
    });
};


/***/ }),

/***/ 3511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ Navbar; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _header_AppBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22991);
/* harmony import */ var _header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10785);






var Navbar = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("height:56px;margin:0 auto;", !props.isUnappliedSticky && "position: sticky;", "        background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";z-index:19;border-top:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLight */ .O9.borderLight, ";border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLight */ .O9.borderLight, ";", !props.isUnappliedSticky && "".concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n          top: calc(").concat(_header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_3__/* .APPBAR_HEIGHT */ .sU, " - 1px);\n        }\n        ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, " {\n          top: calc(").concat(_header_AppBar__WEBPACK_IMPORTED_MODULE_2__/* .APPBAR_HEIGHT */ .sU, " - 1px);\n        }")),
        className: props.className,
        onClick: props.onClick,
        children: props.children
    });
};


/***/ }),

/***/ 23316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ InvestorTabGroup; },
/* harmony export */   "x": function() { return /* binding */ allTabList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18584);
/* harmony import */ var _lib_investor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56027);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73650);
/* harmony import */ var _common_Navbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3511);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                  ",
        " {\n                    font-size: 14px;\n                    height: 32px;\n                  }\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var allTabList = [
    "basic-info",
    "investment-info",
    "companies",
    "seed-funded",
    "acquisitions",
    "partnerships",
    "people",
    "funds",
    "startup-investments",
    "lp-investments",
    "news", 
];
var vcOnlyTab = [
    "investment-info",
    "seed-funded"
];
var cvcOnlyTab = [
    "acquisitions",
    "partnerships"
];
var enterpriseOnlyTab = [
    "funds",
    "startup-investments",
    "lp-investments", 
];
var InvestorTabGroup = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .a)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var check = function() {
        if (ref.current === null) return;
        var activeButton = ref.current.querySelector(".pl-tab.is-active");
        if (activeButton === null) return;
        ref.current.scroll({
            left: activeButton.offsetLeft - 32,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        check();
    }, [
        props.activeTab
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", (0,lodash__WEBPACK_IMPORTED_MODULE_7__.throttle)(check, 200));
        return function() {
            window.removeEventListener("scroll", (0,lodash__WEBPACK_IMPORTED_MODULE_7__.throttle)(check, 200));
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_Navbar__WEBPACK_IMPORTED_MODULE_6__/* .Navbar */ .w, {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("padding:7px 0;height:48px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{height:auto;padding:11px 0;position:sticky;top:160px;z-index:19;}"),
        onClick: props.onChangeTab && props.onChangeTab(props.activeTab),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
            ref: ref,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.untilMedium, "{position:sticky;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}}"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("max-width:1200px;margin:0 auto;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.untilMedium, "{width:min-content;padding:0 16px;}"),
                children: allTabList.map(function(tab, i) {
                    if (!(0,_lib_investor__WEBPACK_IMPORTED_MODULE_4__/* .isVc */ .w8)(props.summary) && vcOnlyTab.includes(tab)) {
                        return null;
                    }
                    if (!(0,_lib_investor__WEBPACK_IMPORTED_MODULE_4__/* .isCvc */ .tI)(props.summary) && cvcOnlyTab.includes(tab)) {
                        return null;
                    }
                    if (!(0,_lib_user__WEBPACK_IMPORTED_MODULE_5__/* .isEnterpriseWithTrial */ .xQ)(user) && enterpriseOnlyTab.includes(tab)) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject(), plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.untilMedium),
                        active: props.activeTab === tab,
                        as: "a",
                        href: "/investors/".concat(props.summary.shortname, "#").concat(tab),
                        count: countOfTab(tab, props.summary.dataCount),
                        children: _lib_investor__WEBPACK_IMPORTED_MODULE_4__/* .investorTabLabel */ .uQ[tab]
                    }, i);
                })
            })
        })
    });
};
var countOfTab = function(tabType, dataCount) {
    switch(tabType){
        case "companies":
            return dataCount.companies;
        case "funds":
            return dataCount.funds;
        case "startup-investments":
            return dataCount.investments;
        case "lp-investments":
            return dataCount.lp;
        case "seed-funded":
            return dataCount.seeds;
        case "acquisitions":
            return dataCount.acquisitions;
        case "partnerships":
            return dataCount.partnerships;
        default:
            return undefined;
    }
};


/***/ }),

/***/ 79181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InvestorTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
// EXTERNAL MODULE: ./lib/url.ts
var lib_url = __webpack_require__(48261);
// EXTERNAL MODULE: ./components/atoms/ShareMenu.tsx
var ShareMenu = __webpack_require__(21632);
// EXTERNAL MODULE: ./lib/sticky.ts
var sticky = __webpack_require__(76830);
// EXTERNAL MODULE: ./components/common/CompanyAndInvestorSummaryBg.tsx
var CompanyAndInvestorSummaryBg = __webpack_require__(94580);
;// CONCATENATED MODULE: ./components/pages/investor/InvestorSummarySection.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        margin-right: 10px;\n                        margin-bottom: 10px;\n                      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                            font-size: 11px;\n                            text-align: center;\n                            color: ",
        ";\n                            line-height: 1.2;\n                          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        margin-right: 10px;\n                        margin-bottom: 10px;\n                      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var COVER_IMAGE_COUNT = 7;
var InvestorSummarySection = function(props) {
    var url = (0,lib_url/* investorUrl */.J4)(props.summary.shortname);
    var cover = randomImageById(COVER_IMAGE_COUNT, props.summary.id);
    var ref = (0,react.useState)(false), isInvestorSummaryStickyPosition = ref[0], setIsInvestorSummaryStickyPosition = ref[1];
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            setIsInvestorSummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                setIsInvestorSummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "summary",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanyAndInvestorSummaryBg/* CompanyAndInvestorSummaryBg */.$, {
                backgroundImage: cover,
                sticky: isInvestorSummaryStickyPosition,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{margin-block-start:24px;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;z-index:1;display:flex;justify-content:end;width:100%;padding-block-start:12px;padding-inline:24px;", dist.mq.large, "{position:static;padding-inline:16px 38px;}"),
                        children: props.summary.updatedAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;color:", dist/* colors.white00 */.O9.white00, ";font-size:12px;line-height:1.25;letter-spacing:0.02em;"),
                            className: "last-updated-at",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "最終更新日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0 5px;"),
                                    children: ":"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    suppressHydrationWarning: true,
                                    children: (0,date/* formatDate */.p6)(props.summary.updatedAt, "yyyy/MM/dd HH:mm")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-end;width:100%;max-width:", isInvestorSummaryStickyPosition && "1120px", ";margin-block-start:auto;margin-inline:auto;padding-inline:24px;color:", dist/* colors.textInvert */.O9.textInvert, ";", dist.mq.large, "{padding-inline:", isInvestorSummaryStickyPosition ? "0" : "80px", ";}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:", isInvestorSummaryStickyPosition ? "center" : "end", ";justify-content:space-between;column-gap:24px;width:100%;", dist.mq.large, "{min-height:", isInvestorSummaryStickyPosition ? "96px" : "80px", ";}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:start;flex-direction:column;column-gap:", isInvestorSummaryStickyPosition ? "16px" : "32px", ";row-gap:16px;min-width:0;margin-block-start:148px;", dist.mq.large, "{align-items:", isInvestorSummaryStickyPosition ? "center" : "end", ";flex-direction:row;margin:0;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-grow:0;flex-shrink:0;", dist.mq.large, "{margin-block-end:", isInvestorSummaryStickyPosition ? "0" : "-80px", ";}"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                src: props.summary.imageUrl,
                                                name: props.summary.name,
                                                size: isInvestorSummaryStickyPosition ? "normal" : "extra-large",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.small, "{width:96px !important;height:96px !important;}")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            className: "desktop",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;row-gap:4px;width:100%;min-width:0;", dist.mq.large, "{row-gap:2px;margin-block-end:", isInvestorSummaryStickyPosition ? "0" : "8px", ";}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CorporateNumber, {
                                                    children: props.summary.corporateNumber
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;color:", dist/* colors.text */.O9.text, ";font-size:24px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.5;letter-spacing:0.01em;overflow-wrap:break-word;transition:font-size 0.16s 0s linear;", dist.mq.large, "{color:", dist/* colors.textInvert */.O9.textInvert, ";font-size:", isInvestorSummaryStickyPosition ? "28px" : "32px", ";line-height:1.25;", isInvestorSummaryStickyPosition && "text-overflow: ellipsis; overflow: hidden; white-space: nowrap;", "}"),
                                                    children: props.summary.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.large, "{flex-grow:0;flex-shrink:0;display:flex;align-items:center;margin-block-end:", isInvestorSummaryStickyPosition ? "0" : "16px", ";}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareMenu/* ShareMenu */.v, {
                                        theme: "dark-bg",
                                        url: url,
                                        title: props.summary.name
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;max-width:1200px;margin:0 auto;min-height:100px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;padding:0px 20px 0px 32px;", dist.mq.large, "{margin:10px 0 10px 185px;}"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                            children: props.summary.description
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MajorDestination, {
                            shortname: props.summary.shortname,
                            list: props.summary.companies
                        })
                    ]
                })
            })
        ]
    });
};
var randomImageById = function(imgCount, id) {
    var n = id % imgCount + 1;
    return "/static/images/investor-cover/investor-cover_00".concat(n, ".jpg");
};
var CorporateNumber = function(props) {
    return props.children ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;letter-spacing:0.5px;", dist.mq.large, "{color:", dist/* colors.textInvert */.O9.textInvert, ";}"),
        className: props.className,
        children: [
            "法人番号",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0 5px;"),
                children: ":"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: props.children
            })
        ]
    }) : null;
};
var Description = function(props) {
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), isOmmited = ref1[0], setIsOmmited = ref1[1];
    (0,react.useEffect)(function() {
        if (!ref || !ref.current) {
            return;
        }
        if (isOverflown(ref.current)) {
            setIsOmmited(true);
        } else {
            setIsOmmited(false);
        }
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;padding-bottom:12px;"),
        className: "description",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: ref,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;line-height:1.6;color:", dist/* colors.black30 */.O9.black30, ";white-space:pre-wrap;", isOmmited !== false && omitStyle, ";", isOmmited && "margin-bottom: 4px"),
                children: props.children
            }),
            isOmmited && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                onClick: function() {
                    return setIsOmmited(false);
                },
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.link */.O9.link, ";text-decoration:underline;font-size:13px;position:absolute;right:0;bottom:0;"),
                children: "すべて見る"
            })
        ]
    });
};
var omitStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:calc(13px * 1.6 * 3);-webkit-line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;");
var isOverflown = function(elm) {
    return elm.scrollHeight > elm.clientHeight || elm.scrollWidth > elm.clientWidth;
};
var isDefaultLogo = function(img) {
    return img.startsWith("/assets/default_company") || img.length === 0;
};
var MAX_DISPLAY_COUNT = 9;
var MajorDestination = function(props) {
    var isOverDisplayCount = props.list.length > MAX_DISPLAY_COUNT;
    var displayableList = isOverDisplayCount ? props.list.slice(0, 8) : props.list.slice(0, 9);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:10px 0;"),
        children: props.list.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "investment-destination",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";"),
                    children: "投資先"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "investments",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:10px 0;flex-wrap:wrap;"),
                    children: [
                        displayableList.map(function(c) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: c.path,
                                as: c.path,
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    className: "company-logo-item",
                                    children: isDefaultLogo(c.imageUrl) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject()),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HoverEffect, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo.Frame */.Dc.Frame, {
                                                size: "large",
                                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), dist/* colors.gray90 */.O9.gray90),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    children: c.name.replace("株式会社", "")
                                                })
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject2()),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HoverEffect, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                src: c.imageUrl,
                                                name: c.name,
                                                size: "large"
                                            })
                                        })
                                    })
                                })
                            }, c.path);
                        }),
                        isOverDisplayCount && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/investor/companies?shortname=".concat(props.shortname),
                            as: "/investors/".concat(props.shortname, "#companies"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                className: "company-logo-display-all",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HoverEffect, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo.Frame */.Dc.Frame, {
                                        size: "large",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.link */.O9.link, ";text-decoration:underline;font-size:13px;"),
                                            children: "すべて見る"
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var HoverEffect = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:0.3s;&:hover{box-shadow:rgba(22,22,22,0.1) 0px 0px 15px 0px;}"),
        children: props.children
    });
};

// EXTERNAL MODULE: ./components/pages/investor/InvestorTabGroup.tsx
var InvestorTabGroup = __webpack_require__(23316);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
;// CONCATENATED MODULE: ./components/pages/investor/InvestorTemplate.tsx









var InvestorTemplate = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* InvestorHead */.hw, {
                investor: props.summary
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorSummarySection, {
                summary: props.summary
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorTabGroup/* InvestorTabGroup */._, {
                summary: props.summary,
                activeTab: props.tab
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";padding-bottom:55px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1200px;margin:0 auto;"),
                    className: props.className,
                    children: [
                        props.children,
                        props.summary.crunchbaseUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;margin-top:40px;line-height:1.5;"),
                            className: "powered-by",
                            children: [
                                "本ページの情報の一部は",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    decoration: "none",
                                    href: props.summary.crunchbaseUrl,
                                    target: "_blank",
                                    children: "Crunchbase"
                                }),
                                "から提供を受けています。"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 56027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ createTwoLayerConditionSelectionStates; },
/* harmony export */   "BE": function() { return /* binding */ toInvestorSearchQuery; },
/* harmony export */   "Dx": function() { return /* binding */ investorTypeOf; },
/* harmony export */   "tI": function() { return /* binding */ isCvc; },
/* harmony export */   "uQ": function() { return /* binding */ investorTabLabel; },
/* harmony export */   "w8": function() { return /* binding */ isVc; }
/* harmony export */ });
/* unused harmony exports fetchArticlesByInvestor, fetchContentfulInvestor, parseInvestorSearchQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _api_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58585);
/* harmony import */ var _article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9427);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79240);







var isVc = function(i) {
    return i.category === "VC" || i.category === "海外VC";
};
var isCvc = function(i) {
    return i.category === "事業法人" || i.category === "地方公共団体/大学/財団/その他基金" || i.category === "金融機関" || i.category === "年金基金" || i.category === "その他" || i.category === "SPC(特別目的会社)";
};
var investorTypeOf = function(i) {
    return isVc(i) ? "vc" : isCvc(i) ? "cvc" : undefined;
};
var investorTabLabel = {
    "basic-info": "企業概要",
    "investment-info": "投資情報",
    companies: "投資先",
    "seed-funded": "シード支援先",
    acquisitions: "買収",
    partnerships: "提携先",
    people: "人物",
    funds: "ファンド",
    "startup-investments": "スタートアップ投資",
    "lp-investments": "LP投資",
    news: "ニュース"
};
var fetchArticlesByInvestor = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(investorId) {
        var articles, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    articles = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticlesByInvestor */ .A5)(investorId)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        articles = data.items.map(function(res) {
                            return (0,_article__WEBPACK_IMPORTED_MODULE_1__/* .convertArticle */ .AP)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.fields), {
                                id: res.sys.id
                            }));
                        });
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        articles
                    ];
            }
        });
    });
    return function fetchArticlesByInvestor(investorId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchContentfulInvestor = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var investor, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    investor = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getContentfulInvestor */ .Vb)(shortname)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        investor = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        investor
                    ];
            }
        });
    });
    return function fetchContentfulInvestor(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var toInvestorSearchQuery = function(keywords, categories, countries, page, industries) {
    var joinedCategories = categories.map(function(category) {
        if (category.subCategories.length !== 0) {
            return category.name + ":" + category.subCategories.join("_");
        } else {
            return category.name;
        }
    }).join(",");
    var joinedCountries = countries.join(",");
    return {
        keywords: keywords,
        categories: joinedCategories,
        countries: joinedCountries,
        page: page,
        industries: industries.join(",")
    };
};
var parseInvestorSearchQuery = function(keywords, categories, countries, page, industries) {
    var parsedCategories = categories.split(",").filter(function(v) {
        return v.length !== 0;
    }).map(function(v) {
        if (v.includes(":")) {
            var nameAndSubCategory = v.split(":");
            return {
                name: nameAndSubCategory[0],
                subCategories: nameAndSubCategory[1].split("_")
            };
        } else {
            return {
                name: v,
                subCategories: []
            };
        }
    });
    var parsedCountries = countries.split(",").filter(function(v) {
        return v.length !== 0;
    }).filter(function(x) {
        return x !== undefined;
    });
    var parsedPage = page !== "" ? Number(page) : 1;
    var parsedIndustries = industries.length > 0 ? industries.split(",") : [];
    return {
        keywords: keywords,
        categories: parsedCategories,
        countries: parsedCountries,
        page: parsedPage,
        industries: parsedIndustries
    };
};
var createTwoLayerConditionSelectionStates = function(condition, allCategories) {
    return allCategories.map(function(category) {
        var initialSubCategories = category.subCategories.map(function(subCategory) {
            var ref, ref1;
            var ref2;
            var status = (ref2 = (ref = condition.categories.find(function(c) {
                return c.name === category.name;
            })) === null || ref === void 0 ? void 0 : (ref1 = ref.subCategories) === null || ref1 === void 0 ? void 0 : ref1.includes(subCategory)) !== null && ref2 !== void 0 ? ref2 : false;
            return {
                name: subCategory,
                status: status
            };
        });
        var checkStatus;
        if (category.subCategories.length === 0) {
            if (condition.categories.map(function(c) {
                return c.name;
            }).includes(category.name)) {
                checkStatus = "FULL_CHECKED";
            } else {
                checkStatus = "NON_CHECKED";
            }
        } else {
            if (initialSubCategories.every(function(s) {
                return s.status;
            })) {
                checkStatus = "FULL_CHECKED";
            } else if (initialSubCategories.some(function(s) {
                return s.status;
            })) {
                checkStatus = "PARTIAL_CHECKED";
            } else {
                checkStatus = "NON_CHECKED";
            }
        }
        return {
            name: category.name,
            children: initialSubCategories,
            status: checkStatus,
            isOpen: false
        };
    });
};


/***/ }),

/***/ 76830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ checkSummaryStickyPosition; }
/* harmony export */ });
/* harmony import */ var _components_header_AppBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22991);

var FIXED_SUMMARY_HEIGHT = 96 + 24;
var SUMMARY_HEIGHT = 360;
var checkSummaryStickyPosition = function() {
    var appBarHeight = Number(_components_header_AppBar__WEBPACK_IMPORTED_MODULE_0__/* .APPBAR_HEIGHT.replace */ .sU.replace("px", ""));
    return appBarHeight + SUMMARY_HEIGHT - FIXED_SUMMARY_HEIGHT < window.scrollY;
};


/***/ })

}]);